module.exports = __webpack_public_path__ + "img/hadamard-yz.aefe2788.svg";